import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const Sort = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.3 14.3L12 18.6L7.7 14.3C7.3 13.9 6.7 13.9 6.3 14.3C5.9 14.7 5.9 15.3 6.3 15.7L11.3 20.7C11.5 20.9 11.7 21 12 21C12.3 21 12.5 20.9 12.7 20.7L17.7 15.7C18.1 15.3 18.1 14.7 17.7 14.3C17.3 13.9 16.7 13.9 16.3 14.3ZM7.7 9.7L12 5.4L16.3 9.7C16.5 9.9 16.7 10 17 10C17.3 10 17.5 9.9 17.7 9.7C18.1 9.3 18.1 8.7 17.7 8.3L12.7 3.3C12.3 2.9 11.7 2.9 11.3 3.3L6.3 8.3C5.9 8.7 5.9 9.3 6.3 9.7C6.7 10.1 7.3 10.1 7.7 9.7Z"
      fill="currentColor"
    />
  </svg>
)

export default Sort
